import { render } from "./yi-qlc.vue?vue&type=template&id=f93438de&scoped=true"
import script from "./yi-qlc.vue?vue&type=script&lang=js"
export * from "./yi-qlc.vue?vue&type=script&lang=js"

import "./yi-qlc.vue?vue&type=style&index=0&id=f93438de&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93438de"]])

export default __exports__